import { TokenStorageService } from './../../../../@core/services/token-storage.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { CoreConfigService } from '@core/services/config.service';
import { PaystackService } from '@core/services/paystack.service';
import { Settings } from '@core/types/settings';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import Stepper from 'bs-stepper';

@Component({
  selector: 'app-fundwallet',
  templateUrl: './fundwallet.component.html',
  styleUrls: ['./fundwallet.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FundwalletComponent implements OnInit {
  public contentHeader: object;
  public user: any
  public data: any

  public siteSettings: Settings;

  submitted: boolean = false
  disable: boolean = false
  amount: any;

  submitted_c: boolean = false
  disable_c: boolean = false

  paymentMethods: any = [
    {
      label: 'Paystack (Online Payment)',
      value: 'paystack'
    },
  ]

  online_payment: any = {
    label: '',
    value: ''
  };

  kyc_type: any = {
    label: '',
    value: ''
  };
  
  kycMethods: any = [
    {
      label: 'BVN Number',
      value: 'BVN'
    },
    // {
    //   label: 'NIN Number',
    //   value: 'NIN'
    // }
  ]

  title = 'Wallet Funding with Card'
  tRef: string = ''

  customer_kyc: any

  constructor(
    private tokenStorage: TokenStorageService,
    private paystackService: PaystackService,
    private sanitizer: DomSanitizer,
    private _coreConfigService: CoreConfigService,
    private api: ApiService
  ) {

    this.api.post('dashboard', {}).subscribe((response: any) => {
      this.data = response; 
    });

    // content header
    this.contentHeader = {
      headerTitle: 'Fund Wallet',
      actionButton: false,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/dashboard'
          },
          {
            name: 'Fund Wallet',
            isLink: false
          }
        ]
      }
    };
    
  }

  selectedMethod: string = '';

  decodeAndSanitizeHtml(encodedHtml: string): SafeHtml {
    // Decode the HTML content
    const decodedHtml = this.decodeHtml(encodedHtml);

    // Sanitize and mark the HTML content as safe
    return this.sanitizer.bypassSecurityTrustHtml(decodedHtml);
  }

  private decodeHtml(encodedHtml: string): string {
    // Implement your HTML decoding logic here
    // You might use a library or a simple function to decode HTML entities
    // For simplicity, you can use a basic function:
    const textarea = document.createElement('textarea');
    textarea.innerHTML = encodedHtml;
    return textarea.value;
  }

  selectKYCMethod($event) {
    // console.log($event)
    this.kyc_type = $event
  }

  selectPaymentMethod(method: string) {
    this.selectedMethod = method;
  }

  selectOnlineMethod($event) {
    // console.log($event)
    this.online_payment = $event
  }

  verifyKYC() {
    if (!this.customer_kyc || !this.kyc_type.value) {
      this.api.alerts("top-end", "error", "All fields are required")
      return
    }
    this.submitted_c = true
    this.disable_c = true
    const param = {
      kyc_type: this.kyc_type.value,
      kyc_value: this.customer_kyc,
      action: 'verify-kyc'
    }
    this.api.post('change-details', param).subscribe((response: any) => {
      this.submitted_c = false
      this.disable_c = false
      if (response.success === true) {
        this.api.alerts("top-end", "success", response.message)
      }else{
        this.api.alerts("top-end", "error", response.message)
      }
    });
  }
  
  makePayment() {
    const payable_amount = parseFloat(this.amount)
    const charge = payable_amount * this.siteSettings.globalSettings.online_charge;
    const pay_amount = (payable_amount + charge)
    
    this.paystackService.initiatePayment(this.siteSettings.defaultSettings?.paystack_public_key[2], pay_amount * 100, this.user.email)
    .then((response) => {
      // Handle successful payment
      // console.log('Payment successful:', response);
      if(response) {
        const param = {
          response: response,
          paystack_ref_code: response.reference, 
          amount: this.amount,
          email: this.user.email,
          action: 'paystack'
        }
        this.api.post('confirm-online-payment', param).subscribe((response: any) => {
          if (response.success === true) {
            this.api.alerts("top-end", "success", "Payment Successfully made and wallet credited")
          }else{
            this.api.alerts("top-end", "error", "Payment was unsuccessful. Contact admin.")
          }
        });

      }
    })
    .catch((error) => {
      // Handle payment error or closure
      // console.error('Payment failed:', error);
      this.api.alerts("top-end", "error", "Payment was cancelled.")
    });
  }


  ngOnInit() {

    // transaction reference
    this.tRef = `${Math.random() *10000000}`

    if (this.tokenStorage.getToken()) {
      this.user = this.tokenStorage.getUser();
    }

    this._coreConfigService.sysConfig().subscribe(config => {
      // console.log("site settings: ", config)
      this.siteSettings = config.data;
    });

    
  }

}
